export default "__VITE_PUBLIC_ASSET__d42d853f__"